import { React, useState, useRef } from "react";
import { useParams } from "react-router-dom";

const MarketAnalysisBookmaker = ({
  eventDetails,
  bookmakerOdds,
  bookmarkData,
}) => {
  const { marketId } = useParams();
  let eventName = "";
  let cat_rnr1 = "";
  let cat_rnr2 = "";
  let cat_rnr3 = "";

  // runner1
  let r1b = 0;
  let r1l = 0;
  let t2Size = 0;
  let t3Size = 0;
  let status1 = "SUSPENDED";

  // runner2
  let r2b = 0;
  let r2l = 0;
  let t4Size = 0;
  let t5Size = 0;
  let status2 = "SUSPENDED";

  // runner3
  let r3b = 0;
  let r3l = 0;

  let t6Size = 0;
  let t7Size = 0;
  let status3 = "SUSPENDED";

  let rnr1s = 0;
  let rnr2s = 0;
  let rnr3s = 0;

  if (eventDetails !== null && eventDetails !== undefined) {
    eventName = eventDetails.evt_evt;
    cat_rnr1 = eventDetails.cat_rnr1;
    cat_rnr2 = eventDetails.cat_rnr2;
    cat_rnr3 = eventDetails.cat_rnr3;
  }

  if (
    bookmakerOdds !== null &&
    bookmakerOdds !== undefined &&
    bookmakerOdds !== ""
  ) {
    //debugger;
    // runner1
    r1b = bookmakerOdds.r1b;
    r1l = bookmakerOdds.r1l;
    t2Size = bookmakerOdds.t2Size;
    t3Size = bookmakerOdds.t3Size;
    status1 = bookmakerOdds.s1;

    //runner2
    r2b = bookmakerOdds.r2b;
    r2l = bookmakerOdds.r2l;
    t4Size = bookmakerOdds.t4Size;
    t5Size = bookmakerOdds.t5Size;
    status2 = bookmakerOdds.s2;

    // runner3
    r3b = bookmakerOdds.r3b;
    r3l = bookmakerOdds.r3l;
    t6Size = bookmakerOdds.t6Size;
    t7Size = bookmakerOdds.t7Size;
    status3 = bookmakerOdds.s3;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div>
      <div
        className="tb-content"
        id="bookmaker_div"
        style={{ display: "", marginTop: "20px" }}
      >
        <div>
          <div style={{ width: "100%" }} className="card card-accent-success">
            <div className="row bg-gray-100 market-head">
              <div className="col-12">
                <strong className="site_family">BOOKMAKER</strong> &nbsp;
                <span
                  className="rules-badge"
                  data-toggle="modal"
                  data-target="#userDetailModal"
                  onClick={() => {
                    const width = 1200;
                    const height = 560;
                    const left =
                      window.screenX + (window.outerWidth - width) / 2;
                    const top =
                      window.screenY + (window.outerHeight - height) / 2;

                    window.open(
                      `/agent/user-book/${marketId}/2`,
                      "UserBookWindow",
                      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                    );
                  }}
                >
                  <i className="fa fa-address-book"></i>
                </span>
              </div>
            </div>

            <div className="row runners">
              <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                <strong style={{ fontSize: "1rem" }} className="site_family">
                  {cat_rnr1}
                </strong>{" "}
                <br />{" "}
                <span>
                  <span class="position-plus site_family">
                    <strong
                      style={{
                        color:
                          parseInt(bookmarkData?.rnr1s) * -1 >= 0
                            ? "green"
                            : "red",
                        display:
                          bookmarkData == undefined || bookmarkData?.rnr1s == ""
                            ? "none"
                            : ""
                      }}
                    >
                      {" "}
                      {formatTruncate(
                        Math.round(bookmarkData?.rnr1s || 0) * -1
                      )}
                    </strong>
                  </span>{" "}
                </span>{" "}
              </div>{" "}
              <div class="col-5 col-md-8 price">
                <div
                  class="row"
                  style={{ display: status1 !== "SUSPENDED" ? "" : "none" }}
                >
                  <div class="col-md-2 d-none d-md-block cta-back">
                    <div id="b3-54600" class="col-12 price site_family">
                      {" "}
                    </div>{" "}
                    <div id="bs3-54600" class="col-12 size site_family">
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-back">
                    <div
                      id="b2-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="bs2-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-6 col-md-2 cta-back">
                    <div
                      id="b1-54600"
                      class="col-12 price site_family"
                      style={{ backgroundColor: "rgb(227, 248, 255)" }}
                    >
                      {r1b}
                    </div>{" "}
                    <div
                      id="bs1-54600"
                      class="col-12 size site_family"
                      style={{ backgroundColor: "rgb(227, 248, 255)" }}
                    >
                      {t2Size}
                    </div>
                  </div>{" "}
                  <div class="col-6 col-md-2 cta-lay">
                    <div
                      id="l1-54600"
                      class="col-md-12 col-sm-12 price site_family"
                      style={{ backgroundColor: "rgb(255, 205, 204)" }}
                    >
                      {r1l}
                    </div>{" "}
                    <div
                      id="ls1-54600"
                      class="col-md-12 col-sm-12 size site_family"
                      style={{ backgroundColor: "rgb(255, 205, 204)" }}
                    >
                      {t3Size}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-lay">
                    <div
                      id="l2-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="ls2-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-lay">
                    <div
                      id="l3-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="ls3-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  style={{
                    lineHeight: "51px",
                    color: "red",
                    textAlign: "center",
                    background: "rgb(236, 236, 237)",
                    textTransform: "uppercase",
                    display: status1 === "SUSPENDED" ? "" : "none"
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    SUSPENDED{" "}
                  </div>{" "}
                </div>
              </div>
            </div>

            <div
              className={
                cat_rnr3 == "NA" ? "row runners lastItemBorder" : "row runners"
              }
            >
              <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                <strong style={{ fontSize: "1rem" }} className="site_family">
                  {cat_rnr2}
                </strong>{" "}
                <br />{" "}
                <span>
                  <span class="position-plus site_family">
                    <strong
                      style={{
                        color:
                          parseInt(bookmarkData?.rnr2s) * -1 >= 0
                            ? "green"
                            : "red",
                        display:
                          bookmarkData == undefined || bookmarkData?.rnr2s == ""
                            ? "none"
                            : ""
                      }}
                    >
                      {" "}
                      {formatTruncate(
                        Math.round(bookmarkData?.rnr2s || 0) * -1
                      )}
                    </strong>
                  </span>{" "}
                </span>{" "}
              </div>{" "}
              <div class="col-5 col-md-8 price">
                <div
                  class="row"
                  style={{ display: status2 !== "SUSPENDED" ? "" : "none" }}
                >
                  <div class="col-md-2 d-none d-md-block cta-back">
                    <div id="b3-54600" class="col-12 price site_family">
                      {" "}
                    </div>{" "}
                    <div id="bs3-54600" class="col-12 size site_family">
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-back">
                    <div
                      id="b2-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="bs2-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-6 col-md-2 cta-back">
                    <div
                      id="b1-54600"
                      class="col-12 price site_family"
                      style={{ backgroundColor: "rgb(227, 248, 255)" }}
                    >
                      {r2b}
                    </div>{" "}
                    <div
                      id="bs1-54600"
                      class="col-12 size site_family"
                      style={{ backgroundColor: "rgb(227, 248, 255)" }}
                    >
                      {t4Size}
                    </div>
                  </div>{" "}
                  <div class="col-6 col-md-2 cta-lay">
                    <div
                      id="l1-54600"
                      class="col-md-12 col-sm-12 price site_family"
                      style={{ backgroundColor: "rgb(255, 205, 204)" }}
                    >
                      {r2l}
                    </div>{" "}
                    <div
                      id="ls1-54600"
                      class="col-md-12 col-sm-12 size site_family"
                      style={{ backgroundColor: "rgb(255, 205, 204)" }}
                    >
                      {t5Size}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-lay">
                    <div
                      id="l2-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="ls2-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>{" "}
                  <div class="col-md-2 d-none d-md-block cta-lay">
                    <div
                      id="l3-54600"
                      class="col-md-12 col-sm-12 price site_family"
                    >
                      {" "}
                    </div>{" "}
                    <div
                      id="ls3-54600"
                      class="col-md-12 col-sm-12 size site_family"
                    >
                      {" "}
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  style={{
                    lineHeight: "51px",
                    color: "red",
                    textAlign: "center",
                    background: "rgb(236, 236, 237)",
                    textTransform: "uppercase",
                    display: status2 === "SUSPENDED" ? "" : "none"
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    SUSPENDED{" "}
                  </div>{" "}
                </div>
              </div>
            </div>

            {cat_rnr3 !== "NA" ? (
              <div class="row runners lastItemBorder">
                <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                  <strong style={{ fontSize: "1rem" }} className="site_family">
                    {cat_rnr3}
                  </strong>{" "}
                  <br />{" "}
                  <span>
                    <span class="position-plus site_family">
                      <strong
                        style={{
                          color:
                            parseInt(bookmarkData?.rnr3s) * -1 >= 0
                              ? "green"
                              : "red",
                          display:
                            bookmarkData == undefined ||
                            bookmarkData?.rnr3s == ""
                              ? "none"
                              : ""
                        }}
                      >
                        {" "}
                        {formatTruncate(
                          Math.round(bookmarkData?.rnr3s || 0) * -1
                        )}
                      </strong>
                    </span>{" "}
                  </span>{" "}
                </div>{" "}
                <div class="col-5 col-md-8 price">
                  <div
                    class="row"
                    style={{ display: status3 !== "SUSPENDED" ? "" : "none" }}
                  >
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div id="b3-54600" class="col-12 price site_family">
                        {" "}
                      </div>{" "}
                      <div id="bs3-54600" class="col-12 size site_family">
                        {" "}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-back">
                      <div
                        id="b2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {" "}
                      </div>{" "}
                      <div
                        id="bs2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {" "}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-back">
                      <div
                        id="b1-54600"
                        class="col-12 price site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {r3b}
                      </div>{" "}
                      <div
                        id="bs1-54600"
                        class="col-12 size site_family"
                        style={{ backgroundColor: "rgb(227, 248, 255)" }}
                      >
                        {t6Size}
                      </div>
                    </div>{" "}
                    <div class="col-6 col-md-2 cta-lay">
                      <div
                        id="l1-54600"
                        class="col-md-12 col-sm-12 price site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {r3l}
                      </div>{" "}
                      <div
                        id="ls1-54600"
                        class="col-md-12 col-sm-12 size site_family"
                        style={{ backgroundColor: "rgb(255, 205, 204)" }}
                      >
                        {t7Size}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l2-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {" "}
                      </div>{" "}
                      <div
                        id="ls2-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {" "}
                      </div>
                    </div>{" "}
                    <div class="col-md-2 d-none d-md-block cta-lay">
                      <div
                        id="l3-54600"
                        class="col-md-12 col-sm-12 price site_family"
                      >
                        {" "}
                      </div>{" "}
                      <div
                        id="ls3-54600"
                        class="col-md-12 col-sm-12 size site_family"
                      >
                        {" "}
                      </div>
                    </div>
                  </div>

                  <div
                    class="row"
                    style={{
                      lineHeight: "51px",
                      color: "red",
                      textAlign: "center",
                      background: "rgb(236, 236, 237)",
                      textTransform: "uppercase",
                      display: status3 === "SUSPENDED" ? "" : "none"
                    }}
                  >
                    <div style={{ width: "100%", textAlign: "center" }}>
                      SUSPENDED{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisBookmaker;
